<template>
  <div :class="{ 'col-lg-offset-1 col-lg-10 m-b-15': defaultClasses }">
    <div class="tag-check-multiselect col-sm-5 col-md-3">
      <div class="ag-grid--custom">
        <div class="ag-ltr">
          <input
            v-model="searchTags"
            class="form-control m-b-20"
            placeholder="Search for Tags"
          >
          <div class="ag-list">
            <div class="ag-checkboxex">
              <div
                v-for="(tag, index) in tagTypes"
                v-if="
                  displayTagType(tag, searchTags) || displayTag(tag, searchTags)
                "
                :style="`height: 24px; top: ${index * 24}px;`"
              >
                <div
                  v-if="!tag.tagName"
                  class="ag-column-select-column-group ag-column-select-indent-0"
                >
                  <span
                    class="ag-column-group-icons"
                    @click="toggleTag(tag.tagType)"
                  >
                    <span
                      class="ag-column-group-opened-icon ag-icon ag-icon-tree-open"
                      :class="{
                        'ag-icon-tree-open': !showTags[tag.tagType],
                        'ag-icon-tree-closed': !!showTags[tag.tagType],
                      }"
                    />
                  </span>

                  <div
                    class="ag-column-select-checkbox ag-labeled ag-label-align-right ag-checkbox ag-input-field"
                  >
                    <div
                      class="ag-input-field-label ag-label ag-hidden ag-checkbox-label"
                    />
                    <div
                      class="ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper"
                      :class="tagTypeCheckClass(tag.tagType)"
                    >
                      <input
                        v-model="tag.checked"
                        class="ag-input-field-input ag-checkbox-input"
                        type="checkbox"
                        @change="changeTypeStatus(tag)"
                      >
                    </div>
                  </div>
                  <span
                    class="ag-icon ag-icon-grip ag-drag-handle ag-column-select-column-group-drag-handle"
                  />
                  <span
                    class="ag-column-select-column-label"
                  >{{ tag.tagType }}
                  </span>
                </div>
                <div
                  v-if="!!tag.tagName"
                  class="ag-column-select-column ag-column-select-add-group-indent ag-column-select-indent-1 ng-animate-disable"
                >
                  <div
                    class="ag-column-select-checkbox ag-labeled ag-label-align-right ag-checkbox ag-input-field"
                  >
                    <div
                      class="ag-input-field-label ag-label ag-hidden ag-checkbox-label"
                    />
                    <div
                      class="ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper"
                      :class="{ 'ag-checked': tag.checked }"
                    >
                      <input
                        class="ag-input-field-input ag-checkbox-input"
                        type="checkbox"
                        :value="tag.checked"
                        @click="
                          changeTagStatus({ ...tag, checked: !tag.checked })
                        "
                      >
                    </div>
                  </div>
                  <span
                    class="ag-icon ag-icon-grip ag-drag-handle ag-column-select-column-drag-handle"
                  />
                  <span class="ag-column-select-column-label">{{
                    tag.tagName
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showSelected"
      class="multi-select-lg tag-check-multiselect col-sm-4 col-md-3"
    >
      <div class="multi-select-container m-t-4">
        <div
          class="multi-select-options-container multi-select-list-container tag-select"
        >
          <input
            v-model="searchSelectedTags"
            class="form-control m-b-20"
            placeholder="Search Selected Tags"
          >
          <div class="multi-select-list">
            <div v-show="noCheckedTag">
              <i class="text-muted">
                {{ $t('BUYER_EXTRA_TAGS_SELECT_A_TAG') }}
              </i>
            </div>

            <div
              v-for="tag in checkedTags"
              v-if="
                tag.tagType
                  .toLowerCase()
                  .includes(searchSelectedTags.toLowerCase()) ||
                  tag.tagName
                    .toLowerCase()
                    .includes(searchSelectedTags.toLowerCase())
              "
              class="multi-select-option"
              @click="removeOption(tag)"
            >
              {{ tag.tagType }} - {{ tag.tagName }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sharedMessages from '@/core/locales';

export default {
  name: 'CheckBoxTagsTree',
  props: {
    availableTags: {
      type: Array,
      default: () => [],
    },
    selectedTags: {
      type: Array,
      default: () => [],
    },
    showSelected: {
      type: Boolean,
      default: false,
    },
    defaultClasses: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      buyerAccessToTags: false,
      showTags: [],
      searchTags: '',
      searchSelectedTags: '',
      tagTypes: [],
    };
  },
  computed: {
    checkedTags() {
      return this.tagTypes.filter(this.filterTagChecked);
    },
    noCheckedTag() {
      // (tagTypes|filter:filterTagChecked).length == 0
      return this.checkedTags.length == 0;
    },
  },
  watch: {
    checkedTags(newVal) {
      this.$emit('update:selectedTags', newVal);
    },
  },
  mounted() {
    this.getTagsWithCategory();
    this.loadSelectedTags();
  },
  methods: {
    loadSelectedTags() {
      const selectedTags = this.selectedTags.map((tag) => {
        if (typeof tag === 'string') return tag.split(':');
        return tag;
      });

      this.tagTypes.forEach(
        (tag, index) => {
          const tagToUpdate = _.cloneDeep(tag);
          tagToUpdate.checked = selectedTags.some(
            (selectedTag) =>
              selectedTag[0] === tag.tagType && selectedTag[1] === tag.tagName
          );
          this.tagTypes.splice(index, 1, tagToUpdate);
        }
      );
    },
    getTagsWithCategory() {
      const tags = _.sortBy(this.availableTags, ['tagType']);
      if (tags && tags.length > 0) {
        let tagType = tags[tags.length - 1].tagType;
        for (var i = tags.length - 1; i >= 0; i--) {
          if (tags[i].tagType != tagType) {
            tags.splice(i + 1, 0, {
              tagType: tagType,
            });
            tagType = tags[i].tagType;
          }
          if (i == 0) {
            tags.splice(0, 0, {
              tagType: tagType,
            });
          }
          this.showTags[tagType] = false;
        }
      }
      this.tagTypes = tags;
    },
    anyTagInsideType(tag, searchTags) {
      this.availableTags.some((t) => {
        return (
          t.tagType == tag.tagType &&
          t.tagName.toLowerCase().includes(searchTags)
        );
      });
    },
    tagTypeCheckClass(tagType) {
      let oneChecked = false;
      let typeClass = 'ag-checked';
      this.tagTypes.forEach((tag) => {
        if (tag.tagType != tagType || !tag.tagName) return;
        if (!tag.checked) {
          typeClass = '';
        } else {
          oneChecked = true;
        }
      });

      return oneChecked && typeClass == '' ? 'ag-indeterminate' : typeClass;
    },
    displayTag(tag, searchTags) {
      searchTags = searchTags.toLowerCase();
      return (
        !!tag.tagName &&
        (tag.tagName.toLowerCase().includes(searchTags) || // Tag name includes text
          tag.tagType.toLowerCase().includes(searchTags)) && // Tag name includes text
        (this.showTags[tag.tagType] || searchTags.length > 3)
      ); // The collapse is shown or the search filter length is greater than 3 (arbitrary value)
    },
    displayTagType(tag, searchTags) {
      searchTags = searchTags.toLowerCase();
      return (
        !tag.tagName &&
        (tag.tagType.toLowerCase().includes(searchTags) ||
          this.anyTagInsideType(tag, searchTags))
      );
    },
    removeOption(removeTag) {
      this.tagTypes.forEach((tag) => {
        if (
          tag.tagType == removeTag.tagType &&
          tag.tagName == removeTag.tagName
        ) {
          tag.checked = false;
          this.changeTagStatus(tag);
        }
      });
    },
    changeTagStatus(checkedTag) {
      const index = this.tagTypes.findIndex((tag) => {
        return (
          tag.tagType == checkedTag.tagType && tag.tagName == checkedTag.tagName
        );
      });

      this.tagTypes.splice(index, 1, checkedTag);

      const allTagsFromTypeAreChecked = this.tagTypes
        .filter((tag) => {
          return tag.tagName && tag.tagType == checkedTag.tagType;
        })
        .some((tag) => {
          return tag.checked;
        });

      this.tagTypes.forEach((tag, index) => {
        if (tag.tagType == checkedTag.tagType && !tag.tagName) {
          if (tag.checked != allTagsFromTypeAreChecked) {
            tag.checked = allTagsFromTypeAreChecked;
            this.tagTypes.splice(index, 1, tag);
          }
        }
      });
    },
    changeTypeStatus(changedTag) {
      this.tagTypes.forEach((tag, index) => {
        if (tag.tagType == changedTag.tagType) {
          if (
            tag.tagName &&
            tag.tagName.toLowerCase().includes(this.searchTags.toLowerCase())
          ) {
            tag.checked = changedTag.checked;
            this.tagTypes.splice(index, 1, tag);
          }
        }
      });
    },
    toggleTag(tagType) {
      this.$set(this.showTags, tagType, !this.showTags[tagType]);
      this.$forceUpdate();
    },
    filterTagChecked(elm) {
      return elm.checked && elm.tagName;
    },
  },
  i18n: {
    sharedMessages,
    locale: 'en',
  },
};
</script>